import { colors } from '../../constants';
import shadows from '../../shadows';
const MuiBadge = {
  badge: {
    boxShadow: shadows[1],
    backgroundColor: colors.commonColors.white
  },
  colorPrimary: {
    boxShadow: 'none'
  },
  colorSecondary: {
    boxShadow: 'none'
  },
  colorError: {
    boxShadow: 'none'
  }
};
export default MuiBadge;